var Response = (function () {
    function Response(rawResponse) {
        if (rawResponse) {
            this.addProperties(rawResponse);
            this.checkModelTypes(rawResponse);
        }
    }
    Object.defineProperty(Response.prototype, "views", {
        get: function () {
            return this.VD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "models", {
        get: function () {
            return this.MD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "viewDeltas", {
        get: function () {
            return this.V ? this.V : this.VD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "modelDeltas", {
        get: function () {
            return this.M ? this.M : this.MD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "modelDeltaTypes", {
        get: function () {
            return this.MT ? this.MT : this.MDT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "switchIds", {
        get: function () {
            return this.SW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "removeIds", {
        get: function () {
            return this.RM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "multipleTabHeader", {
        get: function () {
            return this.headers && this.headers.get(Response.MultiTabHeader);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "tabHeaderId", {
        get: function () {
            return this.headers && this.headers.get(Response.MultiTabHeaderId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "tabHeaderInfo", {
        get: function () {
            return {
                'multipleTabHeader': this.multipleTabHeader,
                'tabHeaderId': this.tabHeaderId
            };
        },
        enumerable: false,
        configurable: true
    });
    Response.prototype.addProperties = function (rawResponse) {
        for (var key in rawResponse) {
            if (rawResponse.hasOwnProperty(key)) {
                this[key] = rawResponse[key];
            }
        }
    };
    Response.prototype.checkModelTypes = function (rawResponse) {
        if (rawResponse.MT) {
            this.associateModelTypes(rawResponse.M, rawResponse.MT);
        }
        if (rawResponse.MDT) {
            this.associateModelTypes(rawResponse.MD, rawResponse.MDT);
        }
    };
    Response.prototype.associateModelTypes = function (models, modelTypes) {
        if (modelTypes && modelTypes.length) {
            for (var i = 0; i < modelTypes.length; i++) {
                this.mergeType(models[i], modelTypes[i]);
            }
        }
    };
    Response.prototype.mergeType = function (model, modelType) {
        if (model && modelType && !model['@k']) {
            model['@k'] = modelType;
        }
    };
    Object.defineProperty(Response.prototype, "added", {
        get: function () {
            return this.Added;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "changed", {
        get: function () {
            return this.Changed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "removed", {
        get: function () {
            return this.Removed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "actions", {
        get: function () {
            return this.Actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "collections", {
        get: function () {
            return this.Collections;
        },
        enumerable: false,
        configurable: true
    });
    Response.MultiTabHeader = 'WM-MultiTb';
    Response.MultiTabHeaderId = 'WM-Tb';
    return Response;
}());
export { Response };
